import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

import { useBrand } from "src/hooks/useBrand";
import { logScreenName } from "src/utils";

interface Props {
  title: string;
}

export const MetaTags = ({ title }: Props) => {
  useEffect(() => logScreenName(title), [title]);
  const { customerPortal, identity } = useBrand();

  return (
    <Helmet titleTemplate={`${customerPortal.name} | %s`}>
      <html lang="fr" data-cy="meta-tags" />
      <title>{title}</title>
      <meta
        name="description"
        content={`Tout l'immobilier ${identity.name} : annonces en achat immobilier et location de nos 550 agences, estimation et vente immobilière, gestion locative de votre bien, syndic de copropriété, location de vacances, investissement, espace client ${customerPortal.name}, déménagement, ...`}
      />
    </Helmet>
  );
};
